import { Availability } from '@susu/headless-commerce/features/configurator/domain/Availability/Availability'
import type { AvailabilityDataAccessObject } from '@susu/headless-commerce/features/configurator/domain/Availability/AvailabilityDataAccessObject'

export class AvailabilityEncoder {
  static encode(instance: Availability): AvailabilityDataAccessObject {
    return {
      productId: instance.productId.value,
      availableToSell: instance.availableToSell.value,
      inStockData: instance.inStockData.value,
      isAvailable: instance.isAvailable.value,
      isStockThresholdReached: instance.isStockThresholdReached.value,
      oneLeft: instance.oneLeft.value,
      preOrder: instance.preOrder.value,
      showBadge: instance.showBadge.value,
    }
  }

  static decode(properties: AvailabilityDataAccessObject) {
    const instance = new Availability(
      properties.productId,
      properties.availableToSell,
      properties.inStockData,
      properties.isAvailable,
      properties.isStockThresholdReached,
      properties.oneLeft,
      properties.preOrder,
      properties.showBadge,
    )

    return instance
  }
}
